<template>
  <b-modal class="clinic-show-category" ref="modal" :title="dialog_title" hide-footer>
    <div class="form-group row">
      <div class="col-sm-4">
        <input v-model="name" type="text" class="form-control" id="show_category_name" />
        <label for="show_category_name" class="wabident-info">Nombre</label>
      </div>
      <div class="col-sm-4">
        <input v-model="slug" type="text" class="form-control" id="show_category_slug" />
        <label for="show_category_slug" class="wabident-info">Código</label>
      </div>
      <div class="col-sm-4">
        <input v-model.number="default_duration" type="number" class="form-control" id="show_category_duration" />
        <label for="show_category_duration" class="wabident-info">Duración por defecto (Minutos)</label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-6">
        <select v-model="parent_id" id="parent_id" class="custom-select">
          <option :value="null">Ninguna</option>
          <option v-for="cat in filtered_categories" :key="cat.id" :value="cat.id">
            {{ cat.name }}
          </option>
        </select>
        <label class="wabident-info" for="limit_sessions">Cat. Superior</label>
      </div>

      <div class="col-sm-6">
        <wabident-color-picker v-model="color"></wabident-color-picker>
        <label class="wabident-info">Color categoría</label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col text-center">
        <button :disabled="is_loading" @click="onDelete" v-show="is_editing" class="btn btn-wabident-delete float-left"
          style="width: 53.6px; height: 53.6px"></button>
        <button :disabled="is_loading || is_invalid" type="button" @click="onSubmit"
          class="btn btn-primary btn-wabident float-right">
          <span v-if="is_loading">Guardando ...</span>
          <span v-else-if="is_editing">Modificar Unidad</span>
          <span v-else>Crear Unidad</span>
          <i v-if="is_loading" class="fas fa-circle-notch float-right"></i>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      slug: "",
      color: { hex: null },
      parent_id: null,
      is_editing: false,
      is_loading: false,
      product_categories: [],
      product_hierarchy: [],
      default_duration: 30,
      category: null,
    };
  },
  computed: {
    filtered_categories() {
      return this.product_categories.filter((cat) => {
        if (!this.is_editing) return true;
        return this.category.id != cat.id;
      });
    },
    is_invalid() {
      return !this.name || this.name == "" || !this.slug || this.slug == "";
    },
    clinic_type() {
      if (!this.clinic) return null;
      return this.clinic.type;
    },
    dialog_title() {
      return this.is_editing ? "Modificar Unidad" : "Nueva Unidad";
    },
    ...mapGetters(["msgwindow", "clinic", "errorwindow"]),
  },
  methods: {
    showNew() {
      this.is_editing = false;
      this.category = null;
      this.name = "";
      this.slug = "";
      this.color = { hex: null };
      this.parent_id = null;
      this.$refs.modal.show();
      this.default_duration = 30;
      this.loadCategories();
    },
    showEdit(category) {
      this.is_editing = true;
      this.category = category;
      this.name = this.category.name;
      this.slug = this.category.slug;
      this.color = { hex: this.category.color };
      this.parent_id = this.category.parent_id;
      this.default_duration = this.category.default_duration;
      this.$refs.modal.show();
      this.loadCategories();
    },
    onSubmit() {
      if (this.is_editing) {
        this.modifycategory();
      } else {
        this.createNewcategory();
      }
    },
    modifycategory() {
      if (!this.is_loading) {
        this.is_loading = true;
        let params = {
          name: this.name,
          slug: this.slug,
          parent_id: this.parent_id,
          color: this.color.hex,
          default_duration: this.default_duration,
        };
        axios
          .post(`/category/${this.category.id}`, params)
          .then((response) => {
            if (response.data.error) {
              this.errorwindow.show("Error", response.data.error);
              this.$emit("submit");
              this.$refs.modal.hide();
            } else {
              this.msgwindow.success("Categoría modificada con éxito");
              this.$emit("submit");
              this.$refs.modal.hide();
            }
          })
          .catch((err) => {
            console.log("[ERR] modifycategory ", err);
            this.msgwindow.error("Error modificando Unidad!");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    createNewcategory() {
      if (!this.is_loading) {
        this.is_loading = true;
        let params = {
          name: this.name,
          slug: this.slug,
          color: this.color.hex,
          parent_id: this.parent_id,
          default_duration: this.default_duration,
        };
        axios
          .post("/category", params)
          .then((response) => {
            if (response.data.error) {
              this.errorwindow.show("Error", response.data.error);
              this.$emit("submit");
              this.$refs.modal.hide();
            } else {
              this.msgwindow.success("Categoría creada con éxito");
              this.$emit("submit");
              this.$refs.modal.hide();
            }
          })
          .catch((err) => {
            console.log("[ERR] createNewCategory ", err);
            this.msgwindow.error("Error creando Unidad!");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    loadCategories() {
      axios.get("/product/categories").then((response) => {
        this.product_categories = response.data;
      });

      axios.get("/product/hierarchy").then((response) => {
        this.product_hierarchy = response.data;
      });
    },
    onDelete() {
      if (!this.is_loading) {
        this.is_loading = true;
        axios
          .post(`/category/${this.category.id}`, { _method: "delete" })
          .then((response) => {
            if (response.data.error) {
              this.errorwindow.show("Error", response.data.error);
              this.$emit("submit");
              this.$refs.modal.hide();
            } else {
              this.msgwindow.success("Categoría borrada con éxito");
              this.$emit("submit");
              this.$refs.modal.hide();
            }
          })
          .catch((err) => {
            console.log("[ERR] onDelete", err);
            this.msgwindow.error("Error borrando Unidad");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss"></style>
